import { COMPANY_LEGAL, legalField } from "./companyLegalInfo";

const TITOLARE = legalField(COMPANY_LEGAL.legalName, 34);
const SEDE = legalField(COMPANY_LEGAL.address, 34);
const PIVA = `P.IVA ${legalField(COMPANY_LEGAL.vatNumber, 16)}${COMPANY_LEGAL.fiscalCode ? ` · C.F. ${COMPANY_LEGAL.fiscalCode}` : ""}`;
const EMAIL_PRIVACY = legalField(COMPANY_LEGAL.privacyEmail, 26);
const EMAIL_SUPPORTO = legalField(COMPANY_LEGAL.supportEmail, 26);
const FORO = legalField(COMPANY_LEGAL.court, 22);
const CLOUD = "infrastruttura cloud gestita nell’Unione Europea";

export const PRIVACY_POLICY = {
  slug: "privacy",
  eyebrow: "INFORMATIVA AI SENSI DEGLI ARTT. 13-14 GDPR",
  title: "Privacy Policy",
  updated: "Ultimo aggiornamento: giugno 2026",
  intro:
    "Officina Tool Control è un servizio software in abbonamento (SaaS) rivolto a imprese e professionisti della meccanica di precisione. Questa informativa spiega quali dati raccogliamo quando visiti il sito, crei un account e usi la piattaforma, per quali finalità li usiamo e quali diritti puoi esercitare.",
  sections: [
    {
      title: "1. Titolare del trattamento",
      paragraphs: [
        `Il titolare del trattamento è ${TITOLARE}, con sede in ${SEDE}, ${PIVA}. Per qualsiasi richiesta relativa ai tuoi dati puoi scrivere a ${EMAIL_PRIVACY}.`,
        COMPANY_LEGAL.dpo
          ? `Il Responsabile della protezione dei dati (DPO) è ${COMPANY_LEGAL.dpo} e può essere contattato all’indirizzo indicato sopra.`
          : "Non è stato nominato un Responsabile della protezione dei dati (DPO): il riferimento per le richieste privacy è l’indirizzo indicato sopra.",
      ],
    },
    {
      title: "2. Quali dati trattiamo",
      bullets: [
        "Dati dell’azienda cliente: ragione sociale, partita IVA, sede, email aziendale, codice SDI.",
        "Dati degli utenti abilitati: nome e cognome, email, telefono, ruolo e permessi, data di nascita se compilata, password in forma cifrata (hash).",
        "Dati tecnici di accesso: indirizzo IP, data e ora delle operazioni, log di sicurezza e di audit (chi ha modificato cosa e quando).",
        "Contenuti caricati da te nel tuo spazio: utensili, componenti, disegni, programmi NC, macchine, commesse, controlli qualità, allegati e relative note.",
        "Dati di fatturazione e di abbonamento: piano attivo, data di inizio e di scadenza della prova, richieste di cambio piano.",
      ],
    },
    {
      title: "3. Finalità e basi giuridiche",
      bullets: [
        "Erogare il servizio e gestire il tuo account: esecuzione del contratto (art. 6.1.b GDPR).",
        "Inviare email di servizio (verifica indirizzo, invito utenti, recupero password, promemoria di scadenza della prova, avvisi tecnici): esecuzione del contratto.",
        "Sicurezza, prevenzione degli abusi, backup e log di audit: legittimo interesse (art. 6.1.f) e obblighi di sicurezza (art. 32).",
        "Adempimenti fiscali, contabili e di legge legati all’abbonamento: obbligo legale (art. 6.1.c).",
        "Statistiche di utilizzo e comunicazioni commerciali non necessarie: consenso (art. 6.1.a), revocabile in qualsiasi momento.",
      ],
    },
    {
      title: "4. Dati che carichi tu: il nostro ruolo di responsabile",
      paragraphs: [
        "I contenuti che carichi nel tuo spazio di lavoro restano tuoi. Se contengono dati personali (per esempio nomi di operatori, referenti di clienti o fornitori), tu agisci come titolare del trattamento e noi come responsabile del trattamento ai sensi dell’art. 28 GDPR: trattiamo quei dati solo per erogare il servizio, secondo le tue istruzioni, senza usarli per finalità proprie.",
        `Su richiesta forniamo l’accordo sul trattamento dei dati (DPA) da sottoscrivere: è sufficiente scrivere a ${EMAIL_PRIVACY}.`,
      ],
    },
    {
      title: "5. Chi tratta i dati per noi",
      paragraphs: ["Ci avvaliamo di fornitori selezionati che agiscono come sub-responsabili:"],
      bullets: [
        "Fornitore di hosting e infrastruttura applicativa dell’ambiente cloud in cui gira la piattaforma.",
        "Fornitore del database gestito (MongoDB) in cui sono archiviati i dati dell’applicazione.",
        "Resend, per l’invio delle email di servizio.",
        "Fornitori di intelligenza artificiale utilizzati per l’estrazione automatica dei dati dai documenti tecnici che carichi (per esempio curve di potenza da schede macchina).",
        "Fornitore dei pagamenti: nessuno, l’incasso online non è ancora attivo. L’elenco verrà aggiornato prima dell’attivazione.",
      ],
    },
    {
      title: "6. Dove sono conservati i dati",
      paragraphs: [
        "I dati sono conservati su infrastruttura cloud all’interno dell’Unione Europea o in Paesi che garantiscono un livello di protezione adeguato. Quando un fornitore tratta dati fuori dallo Spazio Economico Europeo, il trasferimento avviene sulla base delle Clausole Contrattuali Standard approvate dalla Commissione Europea o di una decisione di adeguatezza.",
      ],
    },
    {
      title: "7. Per quanto tempo li conserviamo",
      bullets: [
        "Dati dell’account e contenuti caricati: per tutta la durata del rapporto e per 30 giorni dopo la chiusura, per consentire il recupero.",
        "Backup: copie giornaliere conservate secondo la politica di conservazione impostata nella sezione Sicurezza.",
        "Log di sicurezza e audit: fino a 24 mesi.",
        "Documenti fiscali e contabili: 10 anni, come previsto dalla legge.",
      ],
    },
    {
      title: "8. Sicurezza e backup",
      bullets: [
        "Password conservate solo come hash, mai in chiaro.",
        "Accesso tramite cookie di sessione firmato, con scadenza e rinnovo automatico.",
        "Separazione logica dei dati per azienda (multi-tenant): ogni utente vede solo il database della propria azienda.",
        "Permessi granulari per ruolo e registro di audit delle modifiche.",
        "Backup automatici giornalieri, con possibilità di ripristino e verifica dello stato dalla sezione Sicurezza.",
      ],
    },
    {
      title: "9. I tuoi diritti",
      paragraphs: [
        `Puoi chiedere in qualsiasi momento accesso, rettifica, cancellazione, limitazione, portabilità dei dati e opporti al trattamento basato sul legittimo interesse, scrivendo a ${EMAIL_PRIVACY}. Se ritieni che il trattamento violi la normativa, puoi presentare reclamo al Garante per la protezione dei dati personali (www.garanteprivacy.it).`,
        "Il conferimento dei dati necessari alla registrazione è indispensabile per attivare il servizio: senza di essi non è possibile creare l’account.",
      ],
    },
    {
      title: "10. Aggiornamenti dell’informativa",
      paragraphs: [
        "Se modifichiamo il servizio o i fornitori aggiorniamo questa informativa e, in caso di cambiamenti rilevanti, avvisiamo gli amministratori via email.",
      ],
    },
  ],
};

export const COOKIE_POLICY = {
  slug: "cookie",
  eyebrow: "COOKIE E TECNOLOGIE SIMILI",
  title: "Cookie Policy",
  updated: "Ultimo aggiornamento: giugno 2026",
  intro:
    "Questa pagina spiega quali cookie e tecnologie di archiviazione locale usiamo su Officina Tool Control, a cosa servono e come cambiare le tue scelte in qualsiasi momento.",
  showCookieButton: true,
  sections: [
    {
      title: "1. Cosa sono i cookie",
      paragraphs: [
        "I cookie sono piccoli file che un sito salva sul tuo dispositivo. Alcuni sono indispensabili per far funzionare il servizio, altri servono a misurare l’utilizzo o a fini pubblicitari e richiedono il tuo consenso preventivo.",
      ],
    },
    {
      title: "2. Cookie tecnici necessari (sempre attivi)",
      bullets: [
        "access_token: cookie di sessione firmato che tiene attivo il tuo accesso e si rinnova durante l’uso. Durata: la sessione di lavoro.",
        "otc-cookie-consent-v1: memoria locale (localStorage) in cui salviamo la tua scelta sui cookie, per non richiederla a ogni visita.",
        "Preferenze di interfaccia salvate localmente (per esempio filtri e viste) utili a non perdere il lavoro tra una pagina e l’altra.",
      ],
      paragraphs: [
        "Questi strumenti non richiedono consenso perché senza di essi il servizio richiesto non può essere erogato.",
      ],
    },
    {
      title: "3. Cookie statistici",
      paragraphs: [
        "Servono a capire in forma aggregata quali funzioni vengono usate. Oggi non è attivo alcuno strumento di analisi di terze parti: se lo introdurremo verrà attivato solo dopo il tuo consenso e riportato in questa pagina.",
      ],
    },
    {
      title: "4. Cookie di marketing",
      paragraphs: [
        "Servono a misurare le campagne pubblicitarie e a mostrarti contenuti personalizzati. Oggi non è attivo alcuno strumento di marketing o profilazione.",
      ],
    },
    {
      title: "5. Come cambiare le tue scelte",
      paragraphs: [
        "Puoi rivedere o revocare il consenso in qualsiasi momento dal pannello delle preferenze, senza conseguenze sull’uso della piattaforma: i cookie tecnici restano comunque attivi.",
      ],
    },
    {
      title: "6. Gestione dal browser",
      paragraphs: [
        "Puoi bloccare o cancellare i cookie anche dalle impostazioni del browser (Chrome, Edge, Firefox, Safari). Attenzione: bloccando i cookie tecnici l’accesso al database non resta attivo e dovrai autenticarti a ogni pagina.",
      ],
    },
    {
      title: "7. Titolare e contatti",
      paragraphs: [
        `Il titolare del trattamento è ${TITOLARE}, ${SEDE}, ${PIVA}. Per domande su cookie e privacy scrivi a ${EMAIL_PRIVACY}.`,
      ],
    },
  ],
};

export const TERMS = {
  slug: "termini",
  eyebrow: "CONDIZIONI CONTRATTUALI · CLIENTI BUSINESS",
  title: "Termini e Condizioni",
  updated: "Ultimo aggiornamento: giugno 2026",
  intro:
    "Queste condizioni regolano l’uso di Officina Tool Control, software in abbonamento per la gestione di utensili, magazzino, produzione e qualità. Il servizio è rivolto esclusivamente a imprese e professionisti (contratto B2B): non si applicano le tutele previste per i consumatori.",
  sections: [
    {
      title: "1. Chi fornisce il servizio",
      paragraphs: [
        `Il servizio è fornito da ${TITOLARE}, con sede in ${SEDE}, ${PIVA} ("noi"). Il cliente è l’impresa che registra l’account ("tu").`,
        "L’accettazione avviene con la registrazione dell’account o con l’uso del servizio.",
      ],
    },
    {
      title: "2. Account e responsabilità di accesso",
      bullets: [
        "L’amministratore principale è responsabile degli utenti che invita e dei permessi che assegna.",
        "Le credenziali sono personali: sei responsabile delle attività svolte con gli account della tua azienda.",
        "Devi comunicarci subito ogni uso non autorizzato o sospetto dell’account.",
        "Ogni azienda vede solo i propri dati: non è consentito tentare di accedere ai dati di altri clienti.",
      ],
    },
    {
      title: "3. Piani, prova gratuita e limiti",
      paragraphs: [
        "I piani disponibili sono i seguenti; i prezzi indicati sono IVA inclusa e per singola azienda. Possiamo aggiornare i prezzi dandone comunicazione via email almeno 30 giorni prima: il nuovo prezzo si applica dal rinnovo successivo.",
      ],
      bullets: [
        "Free: 0 €, moduli operativi con limiti: Amministrazione e controllo (sedi, clienti, report produzione), Logistica generale e utensili (1 magazzino, 50 utensili, 50 attacchi base), Produzione (4 macchine, 2 componenti, 4 commesse), 2 utenti.",
        "Easy Tool: 35 € al mese, solo il modulo Logistica generale e utensili senza limiti (catalogo, magazzini, inventario, movimenti), fino a 4 utenti.",
        "Standard: 150 € al mese, moduli Amministrazione e controllo (sedi, clienti, report produzione), Logistica generale e utensili e Produzione senza limiti, fino a 8 utenti.",
        "Premium: 250 € al mese, tutti i moduli compresi Qualità, Preventivazione e Controllo di gestione, utenti illimitati, assistenza con priorità, corso di formazione di 2 giorni e 3 ticket di assistenza gratuiti.",
        "Scegliendo Easy Tool, Standard o Premium in fase di registrazione ottieni 30 giorni di prova gratuita senza carta di credito.",
        "Al termine della prova, se non attivi un piano a pagamento, l’account passa automaticamente al piano Free: i dati restano tutti al loro posto, si applicano soltanto i limiti sui nuovi inserimenti e i moduli Qualità, Preventivazione e Controllo di gestione non sono più accessibili.",
      ],
    },
    {
      title: "4. Attivazione, fatturazione e pagamento",
      paragraphs: [
        "Il pagamento online non è ancora attivo: l’attivazione dei piani a pagamento avviene su richiesta e viene registrata da noi, con emissione di regolare fattura elettronica tramite il codice SDI indicato in fase di registrazione. I termini di pagamento sono quelli riportati in fattura.",
        "In caso di mancato pagamento oltre 15 giorni dalla scadenza possiamo sospendere l’accesso, dopo averti avvisato via email; i dati non vengono cancellati per almeno 30 giorni dalla sospensione.",
      ],
    },
    {
      title: "5. Durata, disdetta e cancellazione dell’account",
      bullets: [
        "L’abbonamento è mensile e si rinnova automaticamente fino a disdetta.",
        "Puoi disdire in qualsiasi momento con effetto alla fine del mese già pagato, senza penali, scrivendo all’indirizzo di assistenza.",
        "Puoi passare a un piano inferiore in ogni momento: i dati restano, cambiano solo i limiti sui nuovi inserimenti.",
        "Alla chiusura dell’account conserviamo i dati per 30 giorni, poi li cancelliamo definitivamente. Prima della chiusura puoi esportare quello che ti serve (Excel e PDF).",
      ],
    },
    {
      title: "6. Uso consentito",
      bullets: [
        "Non è consentito rivendere, sublicenziare o mettere a disposizione di terzi il servizio senza nostro accordo scritto.",
        "Non è consentito caricare contenuti illeciti, malware o dati per cui non hai i diritti necessari.",
        "Non è consentito tentare di aggirare i limiti tecnici del piano, effettuare analisi automatizzate massive o interferire con la stabilità del servizio.",
        "Possiamo sospendere l’accesso senza preavviso in caso di violazioni gravi che mettano a rischio la sicurezza degli altri clienti, informandoti nel più breve tempo possibile.",
      ],
    },
    {
      title: "7. I tuoi dati e la proprietà intellettuale",
      paragraphs: [
        "I contenuti che carichi (utensili, componenti, disegni, programmi NC, dati di produzione e qualità) restano di tua proprietà. Ci autorizzi a trattarli soltanto per erogare il servizio, nei limiti dell’accordo sul trattamento dei dati (DPA).",
        "Il software, l’interfaccia, la documentazione e il marchio restano di nostra proprietà: l’abbonamento ti dà un diritto d’uso non esclusivo e non trasferibile per la durata del contratto.",
        "Possiamo usare dati aggregati e anonimi (mai riconducibili alla tua azienda) per migliorare il prodotto.",
      ],
    },
    {
      title: "8. Livelli di servizio e assistenza",
      paragraphs: [
        "Disponibilità, manutenzioni e tempi di risposta dell’assistenza sono descritti nella pagina Livelli di servizio (SLA). Backup e misure di sicurezza sono descritti nella pagina Sicurezza e backup.",
      ],
    },
    {
      title: "9. Limitazione di responsabilità",
      paragraphs: [
        "Il servizio è uno strumento di supporto alla gestione: le decisioni tecniche e produttive restano tue. Non rispondiamo di danni indiretti, perdita di profitto, fermi produzione o perdita di dati causata da un uso non conforme del servizio o da fatti a te imputabili.",
        "Salvo i casi di dolo o colpa grave, la nostra responsabilità complessiva è limitata a quanto corrisposto nei 12 mesi precedenti l’evento.",
        "Facciamo copie di backup giornaliere, ma resta tua responsabilità conservare copie dei documenti essenziali (disegni, programmi NC) anche fuori dalla piattaforma.",
      ],
    },
    {
      title: "10. Modifiche, legge applicabile e foro",
      paragraphs: [
        "Possiamo aggiornare queste condizioni per motivi tecnici, normativi o di prodotto: le modifiche rilevanti vengono comunicate via email agli amministratori almeno 30 giorni prima.",
        `Il contratto è regolato dalla legge italiana. Per ogni controversia è competente in via esclusiva il Tribunale di ${FORO}.`,
      ],
    },
  ],
};

export const DPA = {
  slug: "dpa",
  eyebrow: "ACCORDO SUL TRATTAMENTO DEI DATI · ART. 28 GDPR",
  title: "DPA — Accordo sul trattamento dei dati",
  updated: "Ultimo aggiornamento: giugno 2026",
  intro:
    "Questo accordo integra i Termini e Condizioni e disciplina il trattamento dei dati personali che carichi nella piattaforma. Tu agisci come titolare del trattamento, noi come responsabile del trattamento. Su richiesta forniamo il documento in PDF da controfirmare.",
  sections: [
    {
      title: "1. Ruoli e oggetto",
      paragraphs: [
        `Titolare: la tua azienda. Responsabile: ${TITOLARE}, ${SEDE}, ${PIVA}.`,
        "Oggetto: trattamento dei dati personali contenuti nel tuo spazio di lavoro, per la sola finalità di erogare il servizio Officina Tool Control secondo le tue istruzioni.",
      ],
    },
    {
      title: "2. Categorie di dati e di interessati",
      bullets: [
        "Interessati: utenti della tua azienda, referenti di clienti e fornitori, operatori indicati nelle fasi di produzione e nei controlli qualità.",
        "Dati: nome e cognome, email aziendale, telefono, ruolo e permessi, log delle attività svolte in piattaforma, eventuali note che inserisci nei documenti.",
        "Non sono richiesti né previsti dati particolari (art. 9 GDPR): ti impegni a non caricarne.",
      ],
    },
    {
      title: "3. Durata e istruzioni",
      paragraphs: [
        "Il trattamento dura quanto il contratto di abbonamento. Trattiamo i dati solo su tua istruzione: la configurazione del servizio, gli utenti che abiliti e i contenuti che carichi costituiscono le istruzioni documentate. Se un’istruzione ci sembra in contrasto con la normativa te lo segnaliamo.",
      ],
    },
    {
      title: "4. Riservatezza e persone autorizzate",
      bullets: [
        "Accedono ai dati solo le persone autorizzate, vincolate alla riservatezza e istruite sul trattamento.",
        "L’accesso del nostro personale ai dati del cliente avviene solo per assistenza o manutenzione, per il tempo necessario e in modo tracciabile.",
      ],
    },
    {
      title: "5. Misure di sicurezza (art. 32 GDPR)",
      bullets: [
        "Cifratura del traffico in transito (HTTPS/TLS).",
        "Password conservate solo come hash, mai in chiaro; sessioni con cookie firmato e scadenza.",
        "Isolamento logico dei dati per azienda (multi-tenant) e permessi granulari per ruolo.",
        "Registro di audit delle modifiche sui documenti sensibili (qualità, componenti, allegati).",
        "Backup automatici giornalieri con procedura di ripristino verificabile dalla sezione Sicurezza.",
        "Dettagli completi nella pagina Sicurezza e backup.",
      ],
    },
    {
      title: "6. Sub-responsabili",
      paragraphs: ["Ci autorizzi ad avvalerci dei seguenti sub-responsabili, ognuno vincolato da obblighi equivalenti a questo accordo:"],
      bullets: [
        `Fornitore di hosting e infrastruttura cloud dell’applicazione: ${CLOUD}.`,
        `Fornitore del database gestito MongoDB: ${CLOUD}.`,
        "Resend (Svezia/UE) per l’invio delle email di servizio.",
        "Fornitori di intelligenza artificiale per l’estrazione automatica dei dati dai documenti tecnici caricati (per esempio curve potenza/coppia dalle schede macchina).",
      ],
    },
    {
      title: "7. Cambio di sub-responsabili",
      paragraphs: [
        "Se sostituiamo o aggiungiamo un sub-responsabile te lo comunichiamo via email agli amministratori con almeno 30 giorni di anticipo. Puoi opporti per motivi ragionevoli: in tal caso puoi recedere dall’abbonamento senza penali.",
      ],
    },
    {
      title: "8. Trasferimenti fuori dall’Unione Europea",
      paragraphs: [
        "I dati sono conservati su infrastruttura nell’Unione Europea o in Paesi con decisione di adeguatezza. Eventuali trasferimenti verso altri Paesi avvengono sulla base delle Clausole Contrattuali Standard della Commissione Europea, con misure supplementari adeguate.",
      ],
    },
    {
      title: "9. Assistenza al titolare",
      bullets: [
        "Ti assistiamo nelle richieste degli interessati (accesso, rettifica, cancellazione, portabilità) mettendo a disposizione gli strumenti della piattaforma e, se necessario, supporto diretto.",
        "Ti assistiamo nelle valutazioni d’impatto (DPIA) e nei rapporti con l’autorità di controllo, per quanto riguarda il nostro trattamento.",
      ],
    },
    {
      title: "10. Violazioni dei dati (data breach)",
      paragraphs: [
        "In caso di violazione dei dati personali ti informiamo senza ingiustificato ritardo e comunque entro 48 ore dalla presa di conoscenza, fornendo natura dell’evento, dati coinvolti, conseguenze probabili e misure adottate, così che tu possa valutare la notifica al Garante entro 72 ore.",
      ],
    },
    {
      title: "11. Cancellazione o restituzione dei dati",
      paragraphs: [
        "Alla fine del contratto puoi esportare i dati dalla piattaforma (Excel e PDF) o richiederne una copia. Trascorsi 30 giorni dalla chiusura cancelliamo i dati e le copie di backup secondo i cicli di rotazione previsti, salvo obblighi di conservazione di legge.",
      ],
    },
    {
      title: "12. Audit",
      paragraphs: [
        `Su richiesta scritta e con ragionevole preavviso ti forniamo le informazioni necessarie a dimostrare la conformità di questo accordo. Le richieste vanno inviate a ${EMAIL_PRIVACY}.`,
      ],
    },
  ],
};

export const SLA = {
  slug: "sla",
  eyebrow: "LIVELLI DI SERVIZIO E ASSISTENZA",
  title: "SLA — Livelli di servizio",
  updated: "Ultimo aggiornamento: giugno 2026",
  intro:
    "Questa pagina descrive la disponibilità del servizio, le finestre di manutenzione e i tempi di risposta dell’assistenza per ciascun piano. I valori indicati sono quelli che ci impegniamo a rispettare.",
  sections: [
    {
      title: "1. Disponibilità",
      bullets: [
        "Disponibilità mensile garantita del servizio: 90%, calcolata sul mese di calendario ed escluse le manutenzioni programmate.",
        "Gli interventi che comportano un fermo del servizio vengono concentrati nelle ore notturne (20:00–06:00 CET), fuori dagli orari di officina.",
        "Il servizio è erogato su infrastruttura cloud con monitoraggio continuo e riavvio automatico dei processi.",
        "Non sono considerate indisponibilità: interruzioni della tua connessione, problemi di rete di terzi, fermi richiesti da te, cause di forza maggiore.",
      ],
    },
    {
      title: "2. Manutenzioni",
      bullets: [
        "Manutenzioni programmate: preferibilmente fuori dagli orari di officina (20:00–06:00 CET) e comunicate agli amministratori con almeno 48 ore di preavviso quando comportano fermo del servizio.",
        "Aggiornamenti evolutivi rilasciati senza fermo del servizio ove tecnicamente possibile.",
        "Manutenzioni urgenti di sicurezza possono essere eseguite senza preavviso, con comunicazione successiva.",
      ],
    },
    {
      title: "3. Classificazione delle segnalazioni",
      bullets: [
        "Bloccante: il servizio non è accessibile o una funzione critica (accesso, prelievi magazzino, salvataggio dati) è inutilizzabile per tutti gli utenti.",
        "Grave: funzione importante non utilizzabile ma con soluzione alternativa disponibile.",
        "Normale: malfunzionamento circoscritto, errore di visualizzazione, dubbio d’uso.",
        "Richiesta evolutiva: nuova funzione o modifica di comportamento, valutata nel piano di sviluppo.",
      ],
    },
    {
      title: "4. Tempi di prima risposta per piano",
      bullets: [
        "Premium (assistenza con priorità): bloccante entro 4 ore lavorative, grave entro 8 ore lavorative, normale entro 1 giorno lavorativo. Include 3 ticket di assistenza gratuiti e il corso di formazione di 2 giorni.",
        "Standard: bloccante entro 8 ore lavorative, grave entro 1 giorno lavorativo, normale entro 2 giorni lavorativi.",
        "Easy Tool: bloccante entro 1 giorno lavorativo, grave e normale entro 3 giorni lavorativi.",
        "Free: assistenza al meglio delle possibilità, senza tempi garantiti.",
        "Orario di lavoro considerato: lunedì–venerdì 9:00–18:00 CET, esclusi i festivi italiani.",
      ],
      paragraphs: [
        "Il tempo di prima risposta è il tempo entro cui una persona prende in carico la segnalazione: la risoluzione dipende dalla natura del problema e viene comunicata con aggiornamenti periodici.",
      ],
    },
    {
      title: "5. Come aprire una segnalazione",
      paragraphs: [
        `Le segnalazioni vanno inviate a ${EMAIL_SUPPORTO} indicando azienda, utente, pagina interessata, cosa ti aspettavi e cosa è accaduto, con eventuale schermata. Le richieste ricevute per altri canali non rientrano nei tempi di risposta.`,
      ],
    },
    {
      title: "6. Rimedi",
      paragraphs: [
        "Se in un mese la disponibilità scende sotto il valore garantito, su tua richiesta scritta entro 30 giorni riconosciamo un’estensione gratuita dell’abbonamento proporzionale al disservizio, fino a un massimo di un mese. Questo è il rimedio esclusivo previsto per il mancato rispetto degli obiettivi di disponibilità.",
      ],
    },
    {
      title: "7. Dati, backup e ripristino",
      paragraphs: [
        "Punto di ripristino (RPO): al massimo 24 ore di lavoro, corrispondenti al backup giornaliero. Tempo di ripristino (RTO): entro 2 giorni lavorativi dalla richiesta di ripristino. Dettagli nella pagina Sicurezza e backup.",
      ],
    },
  ],
};

export const SECURITY_BACKUP = {
  slug: "sicurezza",
  eyebrow: "SICUREZZA, BACKUP E CONTINUITÀ",
  title: "Sicurezza e backup",
  updated: "Ultimo aggiornamento: giugno 2026",
  intro:
    "Qui trovi come proteggiamo i dati della tua officina, come funzionano i backup e come si richiede un ripristino. La sezione Sicurezza dentro l’applicazione mostra in tempo reale lo stato dei backup della tua azienda.",
  sections: [
    {
      title: "1. Protezione degli accessi",
      bullets: [
        "Traffico sempre cifrato in transito (HTTPS/TLS).",
        "Password conservate solo come hash con algoritmo robusto; nessuna password in chiaro, nemmeno nei log.",
        "Sessione con cookie firmato, scadenza automatica e rinnovo durante l’uso.",
        "Protezione contro i tentativi di accesso ripetuti e registro dei tentativi falliti.",
        "Verifica dell’indirizzo email alla creazione dell’account e link di invito a tempo per i nuovi utenti.",
      ],
    },
    {
      title: "2. Separazione dei dati e permessi",
      bullets: [
        "Ogni azienda lavora su uno spazio dati separato (multi-tenant): tutte le richieste sono filtrate per azienda.",
        "Ruoli e permessi granulari per modulo (visitare/gestire), con amministratore principale e possibilità di ruoli personalizzati.",
        "Registro di audit sulle modifiche dei documenti sensibili (componenti, allegati, qualità) con autore e data.",
      ],
    },
    {
      title: "3. Backup",
      bullets: [
        "Backup automatico giornaliero dei dati di ogni azienda, con archivio compresso conservato separatamente dall’applicazione.",
        "Rotazione e scadenza automatica delle copie non più valide; lo stato di ogni backup (disponibile, scaduto, non riuscito) è visibile nella sezione Sicurezza.",
        "Avviso automatico agli amministratori in caso di backup non riuscito.",
        "Puoi richiedere in ogni momento un backup su domanda dalla sezione Sicurezza.",
      ],
    },
    {
      title: "4. Ripristino",
      paragraphs: [
        "Il ripristino riporta i dati dell’azienda alla situazione della copia scelta e sovrascrive i dati correnti: per questo viene eseguito solo su richiesta esplicita di un amministratore, con conferma. Obiettivi di ripristino indicati nella pagina SLA (RPO 24 ore, RTO entro 2 giorni lavorativi).",
      ],
    },
    {
      title: "5. Conservazione e cancellazione",
      bullets: [
        "Dati dell’account e contenuti: per tutta la durata del rapporto e 30 giorni dopo la chiusura.",
        "Copie di backup: secondo la rotazione impostata, poi cancellate automaticamente.",
        "Log di sicurezza e audit: fino a 24 mesi.",
        "Documenti fiscali: 10 anni per obbligo di legge.",
      ],
    },
    {
      title: "6. Infrastruttura e fornitori",
      paragraphs: [
        `L’applicazione gira su ${CLOUD} con database MongoDB e archiviazione degli allegati nello stesso perimetro. L’elenco dei fornitori che trattano dati per nostro conto è nella pagina DPA.`,
      ],
    },
    {
      title: "7. Gestione degli incidenti",
      bullets: [
        "Monitoraggio degli errori applicativi e avvisi interni automatici.",
        "In caso di violazione di dati personali: comunicazione al cliente entro 48 ore dalla presa di conoscenza (vedi DPA).",
        "Correzioni di sicurezza rilasciate con priorità, anche fuori dalle finestre di manutenzione programmate.",
      ],
    },
    {
      title: "8. Cosa spetta a te",
      bullets: [
        "Assegnare i permessi minimi necessari e revocare gli utenti che lasciano l’azienda.",
        "Usare password robuste e non condividere le credenziali tra più persone.",
        "Conservare comunque copie dei documenti essenziali (disegni, programmi NC) anche fuori dalla piattaforma.",
        "Segnalarci subito ogni accesso sospetto.",
      ],
    },
  ],
};

export const LEGAL_DOCS = [
  { slug: "termini", path: "/legale/termini", title: "Termini e Condizioni", doc: TERMS },
  { slug: "privacy", path: "/legale/privacy", title: "Privacy Policy", doc: PRIVACY_POLICY },
  { slug: "cookie", path: "/legale/cookie", title: "Cookie Policy", doc: COOKIE_POLICY },
  { slug: "dpa", path: "/legale/dpa", title: "DPA — Trattamento dati", doc: DPA },
  { slug: "sla", path: "/legale/sla", title: "SLA — Livelli di servizio", doc: SLA },
  { slug: "sicurezza", path: "/legale/sicurezza", title: "Sicurezza e backup", doc: SECURITY_BACKUP },
];
